const metrics = [
  { val: '95%',       unit: '',          label: 'Self-Leveling Performance'  },
  { val: '5',         unit: 'Vehicles',  label: 'Coverage Per 50mL Bottle'  },
  { val: '99.8',      unit: '°',         label: 'Hydrophobic Contact Angle'  },
  { val: '1',         unit: 'Layer',     label: 'Permanent Surface Bond'     },
];

const pillars = [
  {
    icon: 'ri-drop-line',
    title: 'Extreme Hydrophobics',
    body: 'Water, contaminants, and grime bead and shed instantly. Permanent hydrophobic bond that doesn\'t wash away.',
  },
  {
    icon: 'ri-shield-flash-line',
    title: 'Permanent Surface Bond',
    body: 'True permanent bond in a single layer — no reapplication cycles, no temporary protection windows.',
  },
  {
    icon: 'ri-sun-line',
    title: 'UV & Oxidation Defense',
    body: 'Integrated UV blockers in the ceramic matrix prevent paint oxidation, fade, and degradation from sun exposure.',
  },
  {
    icon: 'ri-flashlight-line',
    title: 'Deep Gloss Enhancement',
    body: 'Borograph and Borophene formulations achieve maximum gloss index ratings — producing deep, wet-finish clarity.',
  },
];

const TechSection = () => (
  <section id="technology" className="relative bg-[#030303] py-24 lg:py-32 border-t border-white/5 overflow-hidden">

    {/* ── Full-bleed background image with heavy overlay ── */}
    <div className="absolute inset-0 pointer-events-none">
      <img
        src="https://public.readdy.ai/ai/img_res/0220ab775f7d0bfa46d8dd5d401bdd82.jpg"
        alt="ceramic coating hydrophobic performance"
        className="w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-[#030303]/90" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#030303]/95 via-[#030303]/75 to-[#030303]/95" />
    </div>

    <div className="relative z-10 max-w-[1400px] mx-auto px-6 lg:px-14">

      {/* ── Header ── */}
      <div className="grid lg:grid-cols-[1fr_auto] gap-10 items-end mb-16">
        <div>
          <div className="flex items-center gap-4 mb-5">
            <div className="h-px w-10 bg-[#c9a84c]" />
            <p className="text-[#c9a84c] text-[10px] tracking-[0.32em] font-black">ENGINEERING & PERFORMANCE</p>
          </div>
          <h2
            className="text-white font-black leading-[0.95]"
            style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: 'clamp(34px, 5vw, 62px)', letterSpacing: '-0.03em' }}
          >
            Built Different.<br />
            <span style={{ WebkitTextStroke: '1.5px rgba(255,255,255,0.28)', color: 'transparent' }}>Performs Different.</span>
          </h2>
        </div>
        <p className="text-white/35 text-[13px] max-w-[340px] leading-[1.85] lg:text-right">
          Every NanoPro® formulation is engineered from the ground up — Borophene, Borograph, and Graphene systems designed to exceed all industry benchmarks.
        </p>
      </div>

      {/* ── Big metrics strip ── */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-white/5 mb-16">
        {metrics.map((m) => (
          <div key={m.label} className="bg-[#040404]/80 p-8 lg:p-10 group hover:bg-[#090909] transition-colors duration-300 text-center">
            <div className="flex items-end justify-center gap-1 mb-3">
              <span
                className="text-[#c9a84c] font-black leading-none text-gold-gradient"
                style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: 'clamp(36px, 4vw, 54px)', letterSpacing: '-0.03em' }}
              >
                {m.val}
              </span>
              {m.unit && (
                <span className="text-[#c9a84c]/70 font-bold text-[14px] mb-2">{m.unit}</span>
              )}
            </div>
            <p className="text-white/35 text-[10px] tracking-[0.12em] uppercase">{m.label}</p>
          </div>
        ))}
      </div>

      {/* ── Four pillars ── */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/5">
        {pillars.map((p, i) => (
          <div
            key={i}
            className="bg-[#040404]/80 p-7 lg:p-8 group hover:bg-[#0a0a0a] transition-colors duration-300 relative overflow-hidden"
          >
            {/* Subtle corner gold accent */}
            <div className="absolute top-0 left-0 w-0 h-0 group-hover:w-8 group-hover:h-8 transition-all duration-500 overflow-hidden">
              <div className="absolute top-0 left-0 w-8 h-[1px] bg-[#c9a84c]/50" />
              <div className="absolute top-0 left-0 w-[1px] h-8 bg-[#c9a84c]/50" />
            </div>

            <div className="w-10 h-10 flex items-center justify-center mb-6">
              <i className={`${p.icon} text-[#c9a84c] text-[24px]`} />
            </div>
            <h3
              className="text-white font-bold text-[14px] mb-3 leading-snug"
              style={{ fontFamily: "'Space Grotesk', sans-serif" }}
            >
              {p.title}
            </h3>
            <p className="text-white/38 text-[12px] leading-[1.85]">{p.body}</p>
            <div className="mt-6 h-px w-5 bg-[#c9a84c]/35 group-hover:w-10 transition-all duration-400" />
          </div>
        ))}
      </div>

    </div>
  </section>
);

export default TechSection;
